export function toggleUnique<T>(items: T[], item: T, key: (value: T) => number): T[] {
  return items.some((value) => key(value) === key(item))
    ? items.filter((value) => key(value) !== key(item))
    : [...items, item];
}

export function selectedServiceTotal(items: Array<{ price: string }>): number {
  return items.reduce((sum, item) => sum + (Number(item.price) || 0), 0);
}
